
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gTjY8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b875fe58ddb2396a$export$2e2bcd8739ae039);
/* eslint-disable jira/import-whitelist */ 
var $ebyGx = parcelRequire("ebyGx");

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $jywXF = parcelRequire("jywXF");
const $b875fe58ddb2396a$var$BACKLOG_FETCH_START_MARK = 'UIF_BACKLOG_FETCH_START';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b875fe58ddb2396a$export$2e2bcd8739ae039 = async ({ query: routerQuery, match: match, route: { name: routeName } })=>{
    if (routeName !== 'rapidboard-backlog' && routeName !== 'rapidboard-user-backlog' && routeName !== 'rapidboard-backlog-embed') return null;
    (0, $x9xyg.setMark)($b875fe58ddb2396a$var$BACKLOG_FETCH_START_MARK);
    // As react-resource-router will only return the first query param it finds instead of as possible string[]
    const query = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search) : routerQuery;
    try {
        setTimeout(()=>{
            (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        });
        // Stop query when loading a config page
        if (query.config) return null;
        const { rapidView: rapidView } = query;
        const boardId = match.params.boardId || rapidView;
        const data = await (0, $jywXF.fetchUIFBacklogDataOld)(Number(boardId), query);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.next-gen.backlog.getRestData',
            message: 'An error was thrown while prefetching backlog REST data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("jywXF", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBacklogDataOld", () => $b625b9c23407900e$export$df49ad631c58a3f6);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $b625b9c23407900e$export$60a4d33615c60f8);
$parcel$export(module.exports, "runUIFBacklogEarlyScript", () => $b625b9c23407900e$export$a0c2e05a12ae5621);

var $ebyGx = parcelRequire("ebyGx");

var $tcn7E = parcelRequire("tcn7E");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $cRqmM = parcelRequire("cRqmM");

var $aBK23 = parcelRequire("aBK23");

var $hUQ5s = parcelRequire("hUQ5s");
// Removing isIndexedDBCachingEnabledForBacklog will make this obsolete.
let $b625b9c23407900e$var$backlogResponsePromise;
let $b625b9c23407900e$var$backlogResponse = null;
const $b625b9c23407900e$export$b08a6e96e3de5356 = (response)=>{
    $b625b9c23407900e$var$backlogResponsePromise = response;
};
const $b625b9c23407900e$export$592ab10c6cb9d596 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponsePromise;
    $b625b9c23407900e$var$backlogResponsePromise = null;
    return response;
};
const $b625b9c23407900e$export$55e9294018933a18 = (response)=>{
    $b625b9c23407900e$var$backlogResponse = response;
};
const $b625b9c23407900e$export$b55ab086f6a0c481 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponse;
    $b625b9c23407900e$var$backlogResponse = null;
    return response;
};
const $b625b9c23407900e$var$onEnd = ()=>{
    (0, $x9xyg.setMark)('uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch/request', 'uif-backlog-fetch-start-request', 'uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch', 'uif-backlog-fetch-start', 'uif-backlog-fetch-end');
};
const $b625b9c23407900e$export$df49ad631c58a3f6 = async (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$592ab10c6cb9d596();
    if (earlyScriptResponse) return earlyScriptResponse;
    (0, $x9xyg.setMark)('uif-backlog-fetch-start');
    const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
    (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
    const backlogDataUrl = (0, $4R6GH.fg)('jsw-backlog-resource-data-combine') ? `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data/combined?${queryStr}` : `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
    const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
    const headers = {
        ...enhancedCapabilityHeader ? {
            'X-Atlassian-Capability': enhancedCapabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)());
    const res = await fetch(backlogDataUrl, {
        headers: headers
    });
    let responseData = await res.json().catch(()=>null);
    if (!res.ok) {
        $b625b9c23407900e$var$onEnd();
        const traceId = (0, $l83Uu.getTraceId)(res);
        const message = (0, $aBK23.extractErrorMessage)(responseData);
        if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        else throw new (0, $dO0aE.FetchError)(res.status, message);
    }
    if ((0, $4R6GH.fg)('jsw-backlog-resource-data-combine')) responseData = {
        ...responseData.backlogData,
        boardConfig: responseData.boardConfig,
        globalConfig: responseData.globalConfig
    };
    $b625b9c23407900e$var$onEnd();
    return responseData;
};
const $b625b9c23407900e$export$60a4d33615c60f8 = (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$b55ab086f6a0c481();
    if (earlyScriptResponse) return earlyScriptResponse;
    const requestPromise = (async ()=>{
        (0, $x9xyg.setMark)('uif-backlog-fetch-start');
        const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
        (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
        const backlogDataUrl = (0, $4R6GH.fg)('jsw-backlog-resource-data-combine') ? `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data/combined?${queryStr}` : `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
        const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
        const headers = {
            ...enhancedCapabilityHeader ? {
                'X-Atlassian-Capability': enhancedCapabilityHeader
            } : {}
        };
        Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)());
        const res = await fetch(backlogDataUrl, {
            headers: headers
        });
        let responseData = await res.json().catch(()=>null);
        if (!res.ok) {
            $b625b9c23407900e$var$onEnd();
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(responseData);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        if ((0, $4R6GH.fg)('jsw-backlog-resource-data-combine')) responseData = {
            ...responseData.backlogData,
            boardConfig: responseData.boardConfig,
            globalConfig: responseData.globalConfig
        };
        $b625b9c23407900e$var$onEnd();
        return responseData;
    })();
    const cachedPromise = (0, $cRqmM.getBacklogCachedEntry)(boardId);
    return {
        requestPromise: requestPromise,
        cachedPromise: cachedPromise
    };
};
function $b625b9c23407900e$export$a0c2e05a12ae5621(location) {
    const parsedResult = (0, $aBK23.parseBacklogLocation)(location);
    if (!parsedResult) return false;
    const { boardId: boardId, queryParameters: queryParameters } = parsedResult;
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
        const backlogData = $b625b9c23407900e$export$60a4d33615c60f8(boardId, queryParameters);
        $b625b9c23407900e$export$55e9294018933a18(backlogData);
    } else {
        const backlogData = $b625b9c23407900e$export$df49ad631c58a3f6(boardId, queryParameters);
        $b625b9c23407900e$export$b08a6e96e3de5356(backlogData);
    }
    return true;
}

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});

parcelRegister("cRqmM", function(module, exports) {

$parcel$export(module.exports, "setBacklogCachedEntry", () => $31c19adcc162b6bc$export$a9fe76d96b47f80a);
$parcel$export(module.exports, "getBacklogCachedEntry", () => $31c19adcc162b6bc$export$d01cbd23f4b0c290);

var $sn9QA = parcelRequire("sn9QA");

var $2FZUH = parcelRequire("2FZUH");
const $31c19adcc162b6bc$export$1ba4f312a27970c1 = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-backlog');
async function $31c19adcc162b6bc$export$a9fe76d96b47f80a(boardId, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $31c19adcc162b6bc$export$1ba4f312a27970c1.clearAll();
        return Promise.resolve();
    }
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    return $31c19adcc162b6bc$export$1ba4f312a27970c1.set(key, entry);
}
async function $31c19adcc162b6bc$export$d01cbd23f4b0c290(boardId) {
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    try {
        const entry = await $31c19adcc162b6bc$export$1ba4f312a27970c1.get(key);
        if (!entry) return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $31c19adcc162b6bc$export$1ba4f312a27970c1.remove(key);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("2FZUH", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $ec6817f630f9a6c9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "getAccountId", () => $ec6817f630f9a6c9$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "buildCachedEntryKey", () => $ec6817f630f9a6c9$export$59c82678f286b00f);

var $8QpSo = parcelRequire("8QpSo");

var $sn9QA = parcelRequire("sn9QA");
const $ec6817f630f9a6c9$var$EXPIRATION_TIME = 259200000; // 3 days
function $ec6817f630f9a6c9$export$1ea939691cdc45b8(cachedDataEntry) {
    const timeDelta = Date.now() - cachedDataEntry.timestamp;
    const expirationTime = $ec6817f630f9a6c9$var$EXPIRATION_TIME;
    return timeDelta < expirationTime;
}
const $ec6817f630f9a6c9$export$c1e0336bde96e2dc = (0, $8QpSo.default)(()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector('meta[name="ajs-atlassian-account-id"]');
    return el?.getAttribute('content') ?? null;
});
function $ec6817f630f9a6c9$export$59c82678f286b00f(boardId) {
    const accountId = $ec6817f630f9a6c9$export$c1e0336bde96e2dc() ?? 'no-account-id';
    return `local-device-cache::${accountId}::${boardId}`;
}
const $ec6817f630f9a6c9$export$cc1314e9c2424f02 = (0, $sn9QA.createIndexedDBStorageProvider)('labs-preferences');

});


parcelRegister("aBK23", function(module, exports) {

$parcel$export(module.exports, "convertQuickFiltersToString", () => $2271887588c9e1ef$export$4f216f9114f89403);
$parcel$export(module.exports, "getCachedQuickFilters", () => $2271887588c9e1ef$export$e59cda69449c77c2);
$parcel$export(module.exports, "parseBoardLocation", () => $2271887588c9e1ef$export$97471107364bd76c);
$parcel$export(module.exports, "parseBacklogLocation", () => $2271887588c9e1ef$export$be59cb299ab0331c);
$parcel$export(module.exports, "extractErrorMessage", () => $2271887588c9e1ef$export$8cc545829c7461b0);
$parcel$export(module.exports, "View", () => $2271887588c9e1ef$export$27a5bd065ad55220);
$parcel$export(module.exports, "getViewSettings", () => $2271887588c9e1ef$export$3ae70db4a97563c);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");
const $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX = /\/jira\/software\/c\/?projects\/\w+\/boards\/(\d+)\/?(\?.*)?$/;
const $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX = /\/jira\/people\/[^/]+\/boards\/(\d+)\/?(\?.*)?$/;
// people/project match needs to consider `...:...` ids
const $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX = /\/jira\/(?:software\/c\/)?(?:projects|people)\/[^/]+\/boards\/(\d+)\/backlog\/?(\?.*)?$/;
const $2271887588c9e1ef$var$parsePath = (pathname, pattern)=>{
    const match = pattern.exec(pathname);
    if (!match) return null;
    const boardId = match[1];
    return {
        boardId: Number(boardId)
    };
};
const $2271887588c9e1ef$export$4f216f9114f89403 = (queryParameters)=>{
    // Terminate early for the null/undefined cases
    if (!queryParameters?.quickFilter) return undefined; // This is safe to return as it means the query string will just be excluded
    if (!Array.isArray(queryParameters.quickFilter)) {
        // If for whatever reason an object gets in here
        if (typeof queryParameters.quickFilter === 'object') // Fail gracefully
        return undefined;
        // Ensure that the value is a number
        if (Number.isNaN(Number(queryParameters.quickFilter))) return undefined;
        // this isn't an array. It's probably a string or number which is fine to return as is.
        return `${queryParameters.quickFilter}`;
    }
    // Array passed in is the common case
    // If it is empty, don't include it at all.
    if (queryParameters.quickFilter.length === 0) return undefined;
    return queryParameters.quickFilter.filter((val)=>Number.isInteger(Number(val))).join(',');
};
const $2271887588c9e1ef$export$e59cda69449c77c2 = (feature, boardId)=>{
    const localStorageKey = `__storejs_software_${feature}-filters.${boardId}`;
    const updatedStorageKey = `software.${feature}-filters.${boardId}`;
    let cachedFilters;
    const storage = localStorage;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) // if new keys does not exist, falls back to older keys
    cachedFilters = storage.getItem(updatedStorageKey) || localStorage.getItem(localStorageKey);
    else cachedFilters = storage.getItem(localStorageKey);
    if (!cachedFilters) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { CUSTOM_FILTER: cachedQuickFilters } = JSON.parse(cachedFilters);
    return cachedQuickFilters && cachedQuickFilters.length > 0 ? cachedQuickFilters.join(',') : undefined;
};
const $2271887588c9e1ef$export$97471107364bd76c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX) ?? $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX);
    if (!parsedPath) return null;
    const queryStringParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {};
    // Early termination if the quick filter isnt a part of the query string
    if (!queryStringParameters.quickFilter) return {
        ...parsedPath
    };
    // Guarantee that the quick filter will be returned as an array. This helps with typing further upstream
    const quickFilterArray = Array.isArray(queryStringParameters.quickFilter) ? queryStringParameters.quickFilter : [
        queryStringParameters.quickFilter
    ];
    return {
        ...parsedPath,
        queryParameters: {
            quickFilter: quickFilterArray
        }
    };
};
const $2271887588c9e1ef$export$be59cb299ab0331c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX);
    if (!parsedPath) return null;
    return {
        ...parsedPath,
        queryParameters: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {}
    };
};
const $2271887588c9e1ef$var$isErrorMessagesResponse = (json)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    json?.errorMessages instanceof Array;
const $2271887588c9e1ef$export$8cc545829c7461b0 = (json)=>{
    if ($2271887588c9e1ef$var$isErrorMessagesResponse(json)) {
        const { errorMessages: errorMessages } = json;
        return errorMessages.length ? errorMessages.join(', ') : undefined;
    }
    return undefined;
};
/* Copied from jira/src/packages/software/view-settings/src/services/local-storage/index.tsx
 to reduce bundle size by using native localStorage */ const $2271887588c9e1ef$var$VIEW_SETTINGS = 'view-settings';
const $2271887588c9e1ef$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $2271887588c9e1ef$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $2271887588c9e1ef$export$36e24695f02d4503 = (view)=>{
    if (view && view === $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD) return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
    if ((0, $4R6GH.fg)('jira_view_settings_additional_fields')) switch(view){
        case $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD}`;
        default:
            return $2271887588c9e1ef$var$VIEW_SETTINGS;
    }
    return $2271887588c9e1ef$var$VIEW_SETTINGS;
};
const $2271887588c9e1ef$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>{
    /**
	 * This usage is excluded via package exclusion in jira/ratcheting-rules.tsx
	 * Because it is only a READ Operation, and reads are not blocked in compliant APIs.
	 * This read will be tracked via a compliant API read in following code
	 * - Initializing view-settings panel on board: jira/src/packages/software/view-settings/src/ui/index.tsx
	 * - rendering cards on the board (Implementation In Progress https://hello.jira.atlassian.cloud/browse/PNDR-1926)
	 * More context in this discussion: https://atlassian.slack.com/archives/C02785CLSTW/p1722822320190909
	 */ const localStorageKey = `__storejs_${$2271887588c9e1ef$export$752f3d44db2fbd2d}_${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`;
    const updatedStorageKey = `${$2271887588c9e1ef$export$752f3d44db2fbd2d}.${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`;
    const legacyStorageKey = `__storejs_${$2271887588c9e1ef$export$752f3d44db2fbd2d}_${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`;
    const updatedLegacyStorageKey = `${$2271887588c9e1ef$export$752f3d44db2fbd2d}.${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`;
    const storage = localStorage;
    let viewSettingStorageValue;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) viewSettingStorageValue = storage.getItem(updatedStorageKey) || storage.getItem(updatedLegacyStorageKey) || // if new keys does not exist, falls back to older keys
    storage.getItem(localStorageKey) || storage.getItem(legacyStorageKey);
    else viewSettingStorageValue = storage.getItem(localStorageKey) || // return legacy view settings if prefixed storage doesn't exist
    storage.getItem(legacyStorageKey);
    return JSON.parse(viewSettingStorageValue ?? 'null');
};

});

parcelRegister("hUQ5s", function(module, exports) {

$parcel$export(module.exports, "buildPlanDataFetchOptions", () => $f874c35ef69356eb$export$dab2d96649ebf00a);

var $aBK23 = parcelRequire("aBK23");
const $f874c35ef69356eb$export$68c4c1e22c91f23f = 'fetchBacklogData';
const $f874c35ef69356eb$var$parseActiveQuickFilters = (queryParameters, boardId)=>{
    if (queryParameters?.customFilter && typeof queryParameters?.customFilter === 'string') return queryParameters.customFilter.split(',');
    return (0, $aBK23.getCachedQuickFilters)('backlog', boardId)?.split(',');
};
const $f874c35ef69356eb$export$dab2d96649ebf00a = (boardId, queryParameters)=>({
        rapidViewId: boardId,
        forceConsistency: queryParameters?.forceConsistency ? /true/i.test(String(queryParameters.forceConsistency)) : true,
        activeQuickFilters: $f874c35ef69356eb$var$parseActiveQuickFilters(queryParameters, boardId),
        operation: $f874c35ef69356eb$export$68c4c1e22c91f23f
    });

});




//# sourceMappingURL=async-nextgen-plandata-rest-old.73c249a7.js.map
